module.exports = __webpack_public_path__ + "img/1.d7301da5.jpg";